// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"e1da0b06","394":"d5c3f98e","505":"b56d7679","672":"e46affab","740":"4062b5bb","835":"62e5e74c"}[chunkId] + ".chunk.js";
};